<template>
  <Browser overflow-visible>
    <template #url>
      <span class="text-gray-900">{{ getCopilotDomain(partner.site.domain) }}</span><span class="rounded bg-amber-100 px-1 text-amber-800">?insider={{ insider }}</span>
    </template>

    <div class="relative outline outline-2 -outline-offset-2 outline-amber-400">
      <CopilotHeader
        :first-name="advisor.first_name"
        :last-name="advisor.last_name"
        :phone="advisor.phone"
        :logo="advisor.logo"
        :personal-photo="advisor.personal_photo"
        :styles="partner.styles"
      />
      <span class="absolute -bottom-3 left-1/2 z-10 -translate-x-1/2 whitespace-nowrap rounded-full bg-amber-400 px-3 py-1 text-xs font-semibold text-amber-950 shadow-sm">
        {{ $t('you_on_every_page', 'You, on every page') }}
      </span>
    </div>
    <div class="relative rounded-b-[inherit] border-t">
      <slot>
        <div class="grid aspect-video place-items-center overflow-hidden rounded-b-[inherit] bg-slate-50">
          <Image
            v-if="partner.site.featured_image"
            :media="partner.site.featured_image"
            conversion="cover"
            lazy
            responsive
            :alt="partner.name"
            class="w-full"
          />
          <div
            v-else
            class="flex flex-col items-center space-y-2"
          >
            <Icon
              icon="image-landscape"
              class="text-5xl text-slate-200"
            />
            <span class="text-xs font-semibold text-slate-300">IMAGE PENDING</span>
          </div>
        </div>
      </slot>

      <div class="relative -mx-2 lg:absolute lg:-left-8 lg:-bottom-8 lg:right-0 lg:mr-0">
        <span class="absolute -top-9 left-1/2 z-10 flex -translate-x-1/2 items-center gap-1.5 whitespace-nowrap rounded-full bg-amber-400 px-3 py-1 text-xs font-semibold text-amber-950 shadow-sm lg:-top-[11.5rem] lg:left-[3rem] lg:translate-x-0">
          <Icon
            icon="envelope"
          />
          {{ $t('leads_direct_to_you', 'Leads direct to you') }}
        </span>

        <!-- Clips the back cards to slivers on small screens -->
        <MockupLeadNotification
          avatar="https://i.pravatar.cc/80?img=12"
          subject="Interest in the Fiji expedition"
          body="Hi! Could you send availability for two guests?"
          time-ago="27m ago"
          class="absolute inset-x-2 -top-2 bottom-2 overflow-hidden lg:top-auto lg:bottom-20 lg:left-8 lg:right-auto"
        />
        <MockupLeadNotification
          avatar="https://i.pravatar.cc/80?img=21"
          subject="Interest in the Norwegian Fjords"
          body="Hi! Could you send availability for two guests?"
          time-ago="16m ago"
          class="absolute inset-x-1 -top-1 bottom-1 overflow-hidden lg:top-auto lg:bottom-10 lg:left-4 lg:right-auto"
        />
        <MockupLeadNotification
          avatar="https://i.pravatar.cc/80?img=13"
          subject="Interest in the med cruise"
          body="Hi! I'd love more details on dates and pricing…"
          time-ago="3m ago"
          class="relative lg:absolute lg:bottom-0"
        />
      </div>
    </div>
  </Browser>
</template>

<script setup lang="ts">
import type { Media } from '~/types/media'

withDefaults(defineProps<{
  partner: {
    name: string
    site: {
      domain: string
      featured_image?: Media | null
    }
    styles?: Record<string, string>
  }
  advisor: {
    first_name: string | null
    last_name: string | null
    phone: string | null
    logo: Pick<Media, 'full_url'> | null
    personal_photo: Pick<Media, 'full_url'> | null
  }
  insider?: string
}>(), {
  insider: 'your-name'
})
</script>
